import { render, staticRenderFns } from "./TeacherLeadershipPage.vue?vue&type=template&id=b41ed456&"
import script from "./TeacherLeadershipPage.vue?vue&type=script&lang=ts&"
export * from "./TeacherLeadershipPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports